import Box from "@mui/material/Box";
import MUIDataTable from "mui-datatables";

import TableSkeleton from "../../../../components/skeletons/TableSkeleton";

import { getColumns, getOptions } from "./config";

import { useTranslation } from "react-i18next";
import { useGetUsersChangeLogQuery } from "../../../user/userApiSlice";

const ChangeLog = ({ companyId }) => {
	const { t } = useTranslation();
	const {
		data: changeLog,
		error,
		isLoading,
		isFetching,
	} = useGetUsersChangeLogQuery({ company: companyId });

	if (isLoading || isFetching) {
		return (
			<Box sx={{ mt: "64px" }}>
				<TableSkeleton />
			</Box>
		);
	}

	const columns = getColumns(t);
	const options = getOptions(t);

	return (
		<MUIDataTable
			className="mui-data-table changeLog-table center-all-cells"
			data={changeLog.data}
			columns={columns}
			options={options}
		/>
	);
};

export default ChangeLog;
